module.exports = __webpack_public_path__ + "img/logo.ebbda2be.png";